n
<script setup lang="ts">
  import { overlayOption } from '@/config/overlayCta/overlay'
  import { useGAEventStore } from '@/store/GAEventTracking'
  import { useOverlayCtaStore } from '@/store/OverlayCta'
  import { useRoute, useRouter } from 'vue-router'
  const route = useRoute()
  const router = useRouter()

  const overlayStore = useOverlayCtaStore()

  const gaEvent = useGAEventStore()
  const overlayVisibility = ref<boolean>(true)
  const isDisabledForCertainPages = ref(true)

  watch(
    () => route.path,
    async () => {
      await router.isReady()
      disableForCertainPage()
    },
    { immediate: true }
  )

  function disableForCertainPage() {
    if (overlayOption.disabledPages.includes(route.path)) {
      isDisabledForCertainPages.value = true
    } else {
      isDisabledForCertainPages.value = false
    }
  }
  function overlayClick() {
    // const { link, trackingEvent } = overlayOption
    gaEvent.pushActionEvent({
      event: 'standardMicrositeTrackingEvent',
      interaction: 'overlay_click',
      micrositeSectionNumber: -1,
      micrositeSectionContent: `Overlay`,
      micrositeName: overlayStore.state.micrositeName,
      micrositePhase: overlayStore.state.micrositePhase,
    })
    const overlayLink = overlayStore.state.link.includes('//')
      ? overlayStore.state.link
      : `https://${
          import.meta.env.VITE_APP_ENV === 'live' ? '' : import.meta.env.VITE_APP_ENV + '-'
        }www.nexon.com/maplestory${overlayStore.state.link}`
    window.open(overlayLink, '_blank')
  }

  function toggleOverlay() {
    overlayVisibility.value = !overlayVisibility.value
  }

  const bgRest = `url(${overlayStore.state.overlayRestImage})`
  const bgHover = `url(${overlayStore.state.overlayHoverImage})`
  const arrowRest = `url(${overlayStore.state.arrowRestImage})`
  const arrowHover = `url(${overlayStore.state.arrowHoverImage})`
</script>

<template>
  <div
    v-if="!isDisabledForCertainPages"
    class="overlay-cta__overlay-img"
    :class="{ overlayActive: overlayVisibility }"
    @click="overlayClick"
  ></div>
  <div
    v-if="!isDisabledForCertainPages"
    class="overlay-cta__toggle-icon"
    :class="{ overlayActive: overlayVisibility }"
    @click="toggleOverlay"
  ></div>
</template>

<style lang="scss">
  body.patch-notes {
    .overlay-cta__overlay-img,
    .overlay-cta__toggle-icon {
      display: none;
    }
  }
</style>

<style scoped lang="scss">
  $overlaySizeDesktop: 210px;
  $overlaySizeTablet: 180px;
  $overlaySizeMobile: 180px;
  $overlaySizeMobileSmall: 42vw;

  $_offsetSizeDesktop: 20px;
  $_offsetSizeTablet: 15px;
  $_offsetSizeMobile: 13px;
  $_offsetSizeMobileSmall: 2vw;

  $toggleButtonOffsetDesktop: 275px;
  $toggleButtonOffsetTablet: 230px;
  $toggleButtonOffsetMobile: 230px;
  $toggleButtonOffsetMobileSmall: 52vw;

  .overlay-cta__overlay-img {
    position: fixed;
    bottom: $_offsetSizeDesktop;
    right: $_offsetSizeDesktop;
    width: $overlaySizeDesktop;
    height: $overlaySizeDesktop;
    background: v-bind(bgRest) no-repeat center top / 100% auto;
    opacity: 0;
    transform: scale(1.2);
    transition: background 0.3s, transform 0.3s, opacity 0.3s;
    z-index: 2000;
    pointer-events: none;
    &:hover,
    &:after {
      content: '';
      background-image: v-bind(bgHover);
    }
    &.overlayActive {
      transform: scale(1);
      opacity: 1;
      pointer-events: auto;
      cursor: pointer;
    }
  }

  .overlay-cta__toggle-icon {
    position: fixed;
    bottom: $toggleButtonOffsetDesktop;
    right: $_offsetSizeDesktop;
    width: 36px;
    height: 36px;
    transform: translateY(100%) rotate(180deg);
    background: v-bind(arrowRest) no-repeat center center / 100% auto;
    transition: all 0.3s;
    opacity: 0.6;
    z-index: 2010;
    cursor: pointer;
    &:hover,
    &:after {
      content: '';
      opacity: 1;
      background-image: v-bind(arrowHover);
    }
    &.overlayActive {
      opacity: 1;
      transform: translateY(100%) rotate(0deg);
    }
  }

  @media #{$tablet} {
    .overlay-cta__overlay-img {
      width: $overlaySizeTablet;
      height: $overlaySizeTablet;
      bottom: $_offsetSizeTablet;
      right: $_offsetSizeTablet;
    }
    .overlay-cta__toggle-icon {
      width: 30px;
      height: 30px;
      right: $_offsetSizeTablet;
      bottom: $toggleButtonOffsetTablet;
    }
  }

  @media #{$mobile} {
    .overlay-cta__overlay-img {
      width: $overlaySizeMobile;
      height: $overlaySizeMobile;
      bottom: $_offsetSizeMobile;
      right: $_offsetSizeMobile;
    }
    .overlay-cta__toggle-icon {
      width: 30px;
      height: 30px;
      right: $_offsetSizeMobile;
      bottom: $toggleButtonOffsetMobile;
    }
  }
  @media #{$mobileSmall} {
    .overlay-cta__overlay-img {
      width: $overlaySizeMobileSmall;
      height: $overlaySizeMobileSmall;
      bottom: $_offsetSizeMobileSmall;
      right: $_offsetSizeMobileSmall;
    }
    .overlay-cta__toggle-icon {
      bottom: $toggleButtonOffsetMobileSmall;
      right: $_offsetSizeMobileSmall;
      width: 7vw;
      height: 7vw;
    }
  }
</style>
